import { render, staticRenderFns } from "./InviteCustomerDialogs.vue?vue&type=template&id=2192a7e3&"
import script from "./InviteCustomerDialogs.vue?vue&type=script&lang=js&"
export * from "./InviteCustomerDialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports